//# sourceMappingURL=/s/files/1/0581/3862/4023/t/11/assets/custom.js.map?v=1690432695
// Force font override on all elements including inline styles
function overrideFont() {
  document.querySelectorAll('*').forEach(function(el) {
    el.style.setProperty('font-family', "'Google Sans', sans-serif", 'important');
  });
}

// Run on load
overrideFont();

// Run after dynamic content loads (GemPages/PageFly)
window.addEventListener('load', overrideFont);

// Watch for new elements added by page builders
const observer = new MutationObserver(function() {
  overrideFont();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});